const ID = 'badge';

export default ID;
